import { useTranslation } from "react-i18next";

import Button from "../Button"; 

import b from '../../img/Home/bonus.png';
import el1 from '../../img/Home/el1.png';

function Bonus() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px]">
        <div className="max-w-[1220px] xl:mx-auto">
            <div className="flex flex-col md:flex-row gap-[40px] xl:gap-[110px]">
                <div className="mx-[20px] xl:mx-0">
                    <p className="xl:max-w-[270px] zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21]">
                        {t("main.25")}
                    </p>
                    <p className="xl:max-w-[310px] text-[#000000B2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
                        {t("main.26")}
                    </p>
                </div>
                <div className="flex flex-col items-start relative z-20 mx-[20px] xl:mx-0">
                    <p className="xl:max-w-[310px] font-[500] text-[#000000B2] text-[14px] ibm-plex">
                        {t("main.27")}
                    </p>
                    <div className="h-[62px] w-full md:w-[350px] xl:w-[497px] bg-white border border-[#00000033] mt-[20px] flex items-center gap-[16px] px-[15px]">
                        <div className="w-[6px] h-[6px] bg-[#1E1C21]"></div>
                        <p className="zen-dots text-[#1E1C21] text-[16px] xl:text-[20px]">{t("main.28")}</p>
                    </div>
                    <div className="h-[62px] w-full md:w-[350px] xl:w-[497px] bg-white border border-[#00000033] mt-[6px] xl:mt-[10px] flex items-center gap-[16px] px-[15px]">
                        <div className="w-[6px] h-[6px] bg-[#1E1C21]"></div>
                        <p className="zen-dots text-[#1E1C21] text-[16px] xl:text-[20px]">{t("main.29")}</p>
                    </div>
                    <div className="h-[62px] w-full md:w-[350px] xl:w-[497px] bg-white border border-[#00000033] mt-[6px] xl:mt-[10px] flex items-center gap-[16px] px-[15px]">
                        <div className="w-[6px] h-[6px] bg-[#1E1C21]"></div>
                        <p className="zen-dots text-[#1E1C21] text-[16px] xl:text-[20px]">{t("main.30")}</p>
                    </div>
                    <p className="xl:max-w-[497px] font-[500] text-[#000000B2] text-[14px] ibm-plex mt-[40px] xl:mt-[20px]">
                        {t("main.31")}
                    </p>
                    <Button className="mt-[40px]"/>
                </div>
                <img src={el1} className="absolute right-0 mt-[-300px] homemaintransition2 hidden xl:block" alt="" />
                <img src={b} className="xl:absolute md:hidden xl:block right-0 mt-[-50px] xl:mt-[-170px]" alt="" />
            </div>
        </div>
    </div>
  );
}

export default Bonus;
